import React from "react";
import { withTranslation } from "react-i18next";

import { Modal, ModalBody } from "reactstrap";
import crossIcon from "assets/images/cross.svg";
import Text from "components/Text";
import styles from "../OfficePolicyManagement.module.scss";
import moment from "moment";
import Loader from "components/Loader";
import useMarkAsCompleteStaff from "../hooks/useMarkAsCompleteStaff";

function StaffMarkAsCompleteModal({
  t,
  issaveEmployeeModalOpen,
  setIsSaveEmployeeModalOpen,
  officePolicy,
  handleActionOfficePolicy,
}) {
  const {
    markAsCompleteState,
    submitCompleteOfficePolicy,
    renderWithInputs,
    errors,
    policyDataLoading,
    formRef,
    onHandleChange,
    approver,
    isPolicyAcknowledgementApprovedByEnabled,
    isPolicyAcknowledgementEnabled,
  } = useMarkAsCompleteStaff({
    officePolicy,
    handleActionOfficePolicy,
    setIsSaveEmployeeModalOpen,
    isModalOpen: issaveEmployeeModalOpen,
  });

  return (
    <Modal
      isOpen={issaveEmployeeModalOpen}
      toggle={() => setIsSaveEmployeeModalOpen(false)}
      className={
        "modal-dialog-centered " + styles["mark-as-complete-modal-dialog"]
      }
      modalClassName="custom-modal"
    >
      {policyDataLoading && <Loader />}
      <span
        className="close-btn"
        onClick={() => setIsSaveEmployeeModalOpen(false)}
      >
        <img src={crossIcon} alt="close" />
      </span>
      <ModalBody>
        <form ref={formRef} onSubmit={submitCompleteOfficePolicy}>
          <Text size="25px" marginBottom="10px" weight="500" color="#111b45">
            <span className="modal-title-25">
              {t("officePolicyManagement.completePolicy")}
            </span>
          </Text>
          <div className={"green-main-color-form " + styles["border-radius"]}>
            <div className="d-flex gap-xxs">
              <div className="ch-checkbox mt-2">
                <label>
                  <input
                    type="checkbox"
                    onChange={onHandleChange}
                    name="IsAcknowledged"
                  />
                  <span />
                </label>
              </div>
              <div className={styles["text-color-dark"]}>
                {markAsCompleteState.Acknowledgement &&
                  renderWithInputs(markAsCompleteState.Acknowledgement)}{" "}
                {markAsCompleteState.Summary}
              </div>
            </div>
            {(errors.Acknowledgement || errors.name) && (
              <span className="error-msg">
                {errors.Acknowledgement || errors.name}
              </span>
            )}
          </div>

          {isPolicyAcknowledgementApprovedByEnabled && (
            <div
              className={
                "green-inner-color-form " +
                styles["approval-div"] +
                " " +
                styles["border-radius"]
              }
            >
              <div className={styles["approval-manager-data"]}>
                <span className={styles["data-label"]}>
                  {t("officePolicyManagement.approvedBy")}
                </span>
                <span className={styles["data-value"]}>
                  {officePolicy?.approverId
                    ? `${approver?.firstName || "-"} ${approver?.lastName || "-"}`
                    : officePolicy?.approverName || "-"}
                </span>
                <span className={styles["data-sub-value"]}>
                  {officePolicy?.approverTitle || ""}
                </span>
                <span className={styles["data-subtext"]}>
                  {approver?.designation?.name || ""}
                </span>
              </div>
              <div className={styles["approval-manager-data"]}>
                <span className={styles["data-label"]}>
                  {t("officePolicyManagement.date")}
                </span>
                <span className={styles["data-value"]}>
                  {moment().format("MMM DD, YYYY")}
                </span>
              </div>
            </div>
          )}

          <div className={"green-main-color-form " + styles["border-radius"]}>
            <div className={"d-flex flex-column " + styles["initials"]}>
              <label htmlFor="initials">
                {t("officePolicyManagement.acknowledgedBy")}
              </label>
              <input
                type="text"
                className={styles["input-names"] + " w-100"}
                placeholder="Enter your initials"
                maxLength={100}
                onChange={onHandleChange}
                name="Initials"
              />
            </div>
            {errors.Initials && (
              <span className="error-msg">{errors.Initials}</span>
            )}
            <Text size="12px" color="#6F7788" weight="400" className="mt-3">
              {t("officePolicyManagement.date")}:{" "}
              {moment().format("MMM DD, YYYY")}
            </Text>
          </div>
          <button
            type="submit"
            className="button button-round button-shadow mr-sm-3 mb-3 w-sm-100"
            title={t("accountOwner.addEmployees")}
            onClick={submitCompleteOfficePolicy}
          >
            {t("submit")}
          </button>
          <button
            type="button"
            className="button button-round button-border btn-mobile-link button-dark mb-md-3"
            onClick={setIsSaveEmployeeModalOpen}
            title={t("cancel")}
          >
            {t("cancel")}
          </button>
        </form>
      </ModalBody>
    </Modal>
  );
}

export default withTranslation()(StaffMarkAsCompleteModal);
